import { BaseError } from "@silo/types";

export class GraphError extends BaseError {
  public readonly _tag = "GraphError";
}
